/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForDockerHub extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForDockerHub");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForDockerHub.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForDockerHub>): ServiceAccountCredentialsForDockerHub {
        let obj = Object.assign(new ServiceAccountCredentialsForDockerHub(), model);
        ServiceAccountCredentialsForDockerHub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForDockerHub>): ServiceAccountCredentialsForDockerHub {
        if (!model) return null;
        return ServiceAccountCredentialsForDockerHub.newInstance(<ServiceAccountCredentialsForDockerHub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForDockerHub) {
        if (!obj) return;

        models.ServiceAccountCredentialsForDockerHub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForDockerHub): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForDockerHub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
